import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { Button, TextField } from '@material-ui/core'
import Background from 'assets/images/HR-Background.jpg'
import { AuthLayout } from 'components/AuthLayout/AuthLayout'
import { getProductLogo } from 'utils/logoConfig'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import { useForgotPasswordMutation } from 'generated/graphql'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import React, { useContext, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useHistory } from 'react-router'

interface ForgotProps {
  email: string
}

export const ForgotPassword = props => {
  let history = useHistory()
  const [dialog, setDialog] = useState(false)
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )

  const logo = getProductLogo()

  const [ForgotPassword, { loading, error }] = useForgotPasswordMutation({
    onError: error => {
      console.log('error', error)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg('Email will be sent to reset password')
      console.log('data', data)
      setDialog(true)
    },
  })
  const { handleSubmit, register, errors, control } = useForm<ForgotProps>({
    defaultValues: {
      email: '',
    },
    mode: 'onChange',
    // resolver: yupResolver(ForgotPasswordSchema),
  })
  const onSubmit = data => {
    console.log(data)
    ForgotPassword({
      variables: {
        email: data.email,
      },
    })
  }
  return (
    <AuthLayout logo={logo} image={Background}>
      <span className="page-title">Forget Password</span>
      <form onSubmit={handleSubmit(onSubmit)} id="submit-form">
        <div className="form-box">
          <Controller
            as={TextField}
            fullWidth
            helperText={errors?.email?.message}
            error={errors?.email ? true : false}
            autoComplete="off"
            name="email"
            label="Email"
            required
            control={control}
            ref={register}
          />
          <span className="forget-link" onClick={() => history.push('/login')}>
            Sign In Here
          </span>
        </div>
        <Button
          variant="contained"
          color="primary"
          className="login-btn"
          type="submit"
        >
          Send
        </Button>
      </form>
      <CommonDialog
        fullWidth={true}
        open={dialog}
        onClose={() => setDialog(false)}
        sections={{
          header: {
            title: 'Info',
          },
          body: () => <div>{SystemMsgs.forgotPassword()}</div>,
          footer: {
            actions: [
              {
                displayText: 'Ok',
                props: {
                  onClick: () => history.push('/login'),
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
    </AuthLayout>
  )
}
